export default __webpack_public_path__ + "static/fortuneTelling-223cb914bd83315d45aea8de3d6a1108.png";